import { createLocalContext } from "../../../utils/create-local-context";

export interface MobileNavContext {
  closeDialog: () => void;
  openWalletFlow: () => void;
  openHome: () => void;
}

export const { useMobileNavContext, MobileNavContext } =
  createLocalContext<MobileNavContext>()("MobileNav");
